// extracted by mini-css-extract-plugin
module.exports = {"container":"inline-textarea-input-unclickable-container__2iGIY","input":"inline-textarea-input-unclickable-input__5YBqt"};